module.exports = __webpack_public_path__ + "img/slider2b.5471d506.webp";